<template>
  <div v-if="workspaceID">
    <noray-auth v-if="type === 'noray'" :workspaceID="workspaceID" />
    <char-auth v-else-if="type === 'char'" />
    <dfiles-auth v-else-if="type === 'dfiles'" />
  </div>
</template>
<script>
import {
  mapState
} from 'vuex'
import NorayAuth from './NorayAuth'
import CharAuth from '@/components/CharAuth'
import DfilesAuth from '@/components/DfilesAuth'
export default {
  components: {
    NorayAuth,
    CharAuth,
    DfilesAuth
  },
  props: {
    type: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    workspaceID: null,
  }),
  computed: {
    ...mapState('app',['dtouchWorkspace']),
  },
  watch: {
    dtouchWorkspace () {
      this.workspaceID = this.dtouchWorkspace
    },
  },
  mounted () {
    this.workspaceID = this.dtouchWorkspace
  },
}
</script>

